<template>
  <DefaultLayout>
    <div class="page-header">
      <h1>Credenciales de IA</h1>
      <p class="subtitle">Configura las API keys de los proveedores de IA</p>
    </div>

    <div class="grid-2">
      <Card>
        <template #title>Credenciales Globales</template>
        <template #content>
          <GlobalConfigForm @saved="loadCredentials" />
        </template>
      </Card>

      <Card>
        <template #title>Credenciales del Tenant</template>
        <template #content>
          <TenantConfigForm @saved="loadCredentials" />
        </template>
      </Card>
    </div>
  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import GlobalConfigForm from '../components/credentials/GlobalConfigForm.vue';
import TenantConfigForm from '../components/credentials/TenantConfigForm.vue';
import Card from 'primevue/card';

const loadCredentials = () => {};
</script>

<style scoped>
.page-header { margin-bottom: 1.5rem; }
.page-header h1 { margin-bottom: 0.25rem; color: #1e293b; }
.subtitle { color: #6b7280; }
.grid-2 { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 1.5rem; }
</style>
